//=========================
// ROUTE CONSTANTS
//=========================
export const LANDING = '/';
export const ACTIVITIES = '/activities';
export const LODGING = '/lodging';
export const REGISTRY = '/registry';
export const STORY = '/story';
export const CONFIRMATION = '/confirmation';
export const RSVP = '/RSVP';
export const GUEST_LIST = '/gl';

//=========================
// EXPORT MASTER
//=========================
const exportMaster = {
  LANDING,
  ACTIVITIES,
  LODGING,
  REGISTRY,
  STORY,
  CONFIRMATION,
  RSVP,
  GUEST_LIST,
};

export default exportMaster;



// WEBPACK FOOTER //
// ./src/constants/route.constants.js